import { sidebarNodeTypes } from '../../../config/config';
import { getApiForNodeType } from '../../common/api/api-map';
import { BaseApi } from '../../common/api/base-api.interface';
import { AttentionNodeCreateProps } from '../models/attention-node-create-props';
import { gojsAttentionCursor } from './../../../assets/cursors';
import { createAttentionNode } from './create-attention-node';
import { setupAttentionNode } from './setup-attention-node';

export const attentionNodeAPI = (): BaseApi<AttentionNodeCreateProps> => ({
  name: sidebarNodeTypes.attentionNode,
  setup: setupAttentionNode,
  create: createAttentionNode,
  getCursor: () => gojsAttentionCursor,
  ...getApiForNodeType(sidebarNodeTypes.attentionNode),
});
